var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.361,
    height: 18.837,
    viewBox: "0 0 17.361 18.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "layers-violet",
    d: "M19.27,12.707l-1.742-1.033,1.653-.945a1.136,1.136,0,0,0,.62-.945,1.081,1.081,0,0,0-.561-.945L17.263,7.658l1.978-1.092a1.136,1.136,0,0,0,.62-.945,1.081,1.081,0,0,0-.561-.945L11.948.277a.93.93,0,0,0-1.092,0L3.061,4.617a1.2,1.2,0,0,0-.561.945,1.081,1.081,0,0,0,.561.945L5.1,7.6,3.061,8.78a1.076,1.076,0,0,0,0,1.89l1.8,1.033-1.8,1.033a1.076,1.076,0,0,0,0,1.89l7.706,4.163a1.221,1.221,0,0,0,.561.148,2.264,2.264,0,0,0,.561-.148l7.322-4.163a1.075,1.075,0,0,0,.059-1.919ZM4.626,5.562l6.791-3.868,6.377,3.868-6.466,3.6Zm0,4.163L6.752,8.544l4.015,2.214a.774.774,0,0,0,.561.148h.089a.807.807,0,0,0,.561-.236l3.779-2.126,2.037,1.181-6.377,3.632Zm6.7,7.558-6.7-3.632,1.89-1.092,4.252,2.362a1.221,1.221,0,0,0,.561.148,2.264,2.264,0,0,0,.561-.148l4.1-2.362,1.8,1.092Z",
    transform: "translate(-2.5 -0.1)",
    fill: "#6c5b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTask);
export default __webpack_public_path__ + "static/media/PendingTask.d7f9d75604f7691075055ce9800f7d53.svg";
export { ForwardRef as ReactComponent };